import { USER_ROLES } from 'admin/users/userUtils';
import { AuthContext } from 'common/providers/AuthContextProvider/AuthContextProvider';
import { Role, useCurrentUserQuery } from 'generated/graphql';
import { useContext } from 'react';
import { Datagrid, DateField, EditButton, ReferenceField, SelectField, TextField } from 'react-admin';

import { USER_INVITATION_STATUS_CHOICES } from './userInvitationUtils';

export const UserInvitationDatagrid: React.FC = () => {
  const { isAuthenticated } = useContext(AuthContext);
  const { data } = useCurrentUserQuery({ skip: !isAuthenticated });

  const hasAnyRole = (allowedRoles: Role[]) =>
    isAuthenticated && data?.user?.roles?.some((role: Role) => allowedRoles.includes(role));

  const showEditButton = hasAnyRole([Role.RoleAdmin]);

  return (
    <Datagrid bulkActionButtons={false} rowClick="show">
      <TextField label="ID" source="id" />
      <ReferenceField label="Pozývatel" reference="User" source="inviter.id">
        <TextField source="email" />
      </ReferenceField>
      <TextField label="E-mail" source="email" />
      <SelectField choices={USER_ROLES} label="Rola" source="role" />
      <SelectField choices={USER_INVITATION_STATUS_CHOICES} label="Status" source="status" />
      <DateField label="Dátum vytvorenia" locales="sk" source="creationTimestamp" />
      <DateField label="Dátum zmeny" locales="sk" source="updateTimestamp" />
      {showEditButton && <EditButton />}
    </Datagrid>
  );
};
